import { render, staticRenderFns } from "./RelatedVersion.vue?vue&type=template&id=204df335&scoped=true"
import script from "./RelatedVersion.vue?vue&type=script&lang=ts"
export * from "./RelatedVersion.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./RelatedVersion.vue?vue&type=style&index=0&id=204df335&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "204df335",
  "337c75c0"
  
)

export default component.exports